import modal from '@/utils/modal'
import ReportModal from './index.vue'

export default function openReportModal(comment) {
    const m = modal.create(ReportModal, true, { persistent: false });
    m.app.setComment(comment);
}
